//Built-in libraries
import { useEffect, useState } from 'react';

//Third party libraries
import { useFormContext } from 'react-hook-form';

//Custom components
import { HookInput } from 'components/UI/HookForm/Form/Input';
import Button from 'components/UI/Button';
import ProposedFinance from './ProposedFInance';
import { HookTextarea } from 'components/UI/HookForm/Form/TextArea';
import { HookRadioGroup } from 'components/UI/HookForm/Form/RadioGroup';

//Services
import { useApplicationFormContext } from 'features/ApplicationForm/ApplicationFormProvider';

//STP Libraries

//Assets and Miscellaneous

//Component Begin

export default function ProjectOverview() {
  const [formError, setFormError] = useState({
    section2: '',
  });

  const { setCurrentStep, data, updateData } = useApplicationFormContext();
  const {
    watch,
    trigger,
    getValues,
    formState: { isValid },
  } = useFormContext();
  const hasPortion = watch('step3.hasPortion');
  const { step3 } = getValues();

  useEffect(() => {
    if (data.step3.section2.length > 0) {
      setFormError((prev) => {
        return { ...prev, section2: '' };
      });
    }
  }, [data]);

  const nextHandler = () => {
    trigger();
    if (!isValid) return;

    if (data.step3.section2.length === 0) {
      setFormError({ section2: 'At least one is required' });
    } else {
      updateData({
        step3: {
          ...step3,
          section2: data?.step3?.section2,
        },
      });
      setCurrentStep((prevState) => prevState + 1);
    }
  };

  return (
    <div className='sm:rounded-r-md sm:overflow-hidden'>
      <div className='py-6 px-4 space-y-6 sm:p-6'>
        <h3 className='text-lg leading-6 font-medium text-green-500'>
          Project Overview
        </h3>
        <div className='flex flex-col gap-10'>
          <section className='space-y-4'>
            <div className='grid grid-cols-6 gap-4'>
              <div className='col-span-6'>
                <HookTextarea
                  label='Describe proposed “project” being undertaken.'
                  id='project-overview-project-description'
                  name='step3.projectDescription'
                  placeholder='e.g. awning replacement, cornice repair. This narrative should describe the same project outlined by the financial.'
                  rows={5}
                />
              </div>
              <HookInput
                customClassName='col-span-6 md:col-span-3'
                label='Project Start Date'
                id='project-overview-begin-date'
                name='step3.beginDate'
                type='date'
              />
              <HookInput
                customClassName='col-span-6 md:col-span-3'
                label='Project Completion Date'
                id='project-overview-completion-date'
                name='step3.completionDate'
                type='date'
              />
              <HookRadioGroup
                className='col-span-6 md:col-span-6'
                label='Has any portion of the project been started yet?'
                name='step3.hasPortion'
                id='project-overview-portion'
                options={[
                  { label: 'Yes', value: 'yes' },
                  { label: 'No', value: 'no' },
                ]}
              />
              {hasPortion === 'yes' && (
                <div className='col-span-6'>
                  <HookTextarea
                    label=''
                    name='step3.portionDescription'
                    placeholder='Please describe the portion started'
                    rows={5}
                  />
                </div>
              )}
            </div>
          </section>
        </div>
        <ProposedFinance formValues={step3} />
        {formError.section2.length > 0 && (
          <p className='text-tertiaryColor-normal'>{formError.section2}</p>
        )}
        <div className='flex gap-4 justify-end mt-5'>
          <Button
            label='Previous'
            btnStyle='neutral'
            type='button'
            onClick={() => setCurrentStep((prev) => prev - 1)}
          />
          <Button
            label='Next'
            btnStyle='primary'
            type='button'
            onClick={nextHandler}
          />
        </div>
      </div>
    </div>
  );
}
